<template>
<div>
  <div class="aw-imgbanner-container">
    <img src="../../assets/aw-herobanner.png"/>
    <div class="img-caption">
    <div>
      <h1>Kontakta oss</h1>
      </div>

    </div>
  </div>
</div>
</template>